import ConnectivityClotService from "../../lib/ssu/input_models/connectivity-clot-service";
import * as types from '../mutation-types';
import logger from "../../lib/logger";
import {SELF_SIGNUP_SET_ATTRIBUTION_DATA} from "../mutation-types";


const clot_action = 'clot_action';
const new_action = 'new';
const none_action = 'none';


const getDefaultOutputClotModel = () => {
  return {
    service_class_id: '',
    service_action_type: clot_action,
    connectivity: {
      service_class_id: -1,
      service_action_type: none_action,
      speed_id: '',
      external_adid: '',
      external_soid: '',
      early_signup: false,
      customer_details: {
        is_owner: true,
        is_tribal: false,
        owner_name: '',
        owner_phone: '',
        owner_email: '',
        city_customer_id: '',
        city_account_id: ''
      },
      drop_details: {
        accepted: true,
        latitude: '',
        longitude: '',
        notes: '',
        needs_ont_install: false
      },
      install_details: {
        date: '',
        display_time: '',
        duration: 0,
        end_datetime: '',
        external_install_id: '',
        installation_type: '',
        notes: '',
        start_datetime: '',
        time: 0
      }
    },
    router: {
      service_class_id: -1,
      service_action_type: none_action,
      external_soid: '',
      router_model: '',
      mesh_quantity: 0,
      mesh_type: 'mesh_none'
    },
    voice: {
      service_class_id: -1,
      service_action_type: none_action,
    },
    static_ip: {
      service_class_id: -1,
      service_action_type: none_action,
    },
    subnet: {
      service_class_id: -1,
      service_action_type: none_action,
    }
  }
}


const getDefaultOutputModel = () => {
    return {
    services: [],
    customer: {
      email: '',
      fname: '',
      lname: '',
      name: '',
      uid: '',
      password: '',
      line1: '',
      line2: '',
      zip_code: '',
      city: '',
      phone: '',
      state: '',
      dob: '',
      attribution: ''
    },
    payment: {
      account_type: '',
      auto_pay: true,
      alternate_billing_address: null,
      card_details: {
        internal_token: '',
        token: '',
        fname: '',
        lname: '',
        exp_month: 0,
        exp_year: 0,
        last_four: '',
        brand: '',
      },
      bank_details: {
        name: '',
        routing: '',
        account: '',
        account_type: ''
      },
      billing_address: {
        fname: '',
        lname: '',
        mnami: '',
        cmp_name: '',
        line1: '',
        line2: '',
        city: '',
        state: '',
        zip_code: '',
        zip_ext: ''
      }
    },
    agreement: {
      time: ''
    },
    metadata: {
      signup_hash: ''
    }
  }
}


const state = {
  address_details: {
    line1: '',
    line2: '',
    city: '',
    state: '',
    zip_code: '',
    address_id: '',
    drop_latitude: '',
    drop_longitude: '',
    needs_ont_install: true,
    formatted_address: '',
    early_signup: false,
    in_service: false,
    is_business: false,
    orderable: false,
    disabled: false,
    available: false,
  },

  init_values: {
    signup_hash: '',
    google_address_id: '',
    formatted_address: '',
    fname: '',
    mname: '',
    lname: ''},

  connectivity_clot_input_model: null,
  connectivity_clot_output_model: getDefaultOutputClotModel(),
  ssu_output_model: getDefaultOutputModel()
}


const helpers = {
  triggerConnectivityClotUpdate(state) {
    state.connectivity_clot_output_model = {...state.connectivity_clot_output_model};
  },
  getInitialValue(key, obj, default_val) {
    if (key in obj) {
      try {
        return obj[key];
      } catch (error) {
        return default_val;
      }
    }
    return default_val;
  },
  setInitialValues(state) {
    state.init_values.formatted_address = state.address_details.formatted_address;
    state.init_values.fname = state.ssu_output_model.customer.fname;
    state.init_values.mname = state.ssu_output_model.customer.mname;
    state.init_values.lname = state.ssu_output_model.customer.lname;
  }
}


const getters = {
  ssuInitDetails: state => {
    return state.init_values;
  },
  ssuInitGoogleAddressId: state => {
    return state.init_values.google_address_id;
  },
  ssuSelectedSpeedId: state => {
    return state.connectivity_clot_output_model.connectivity.speed_id;
  },
  ssuServiceDetails: state => {
    return state.connectivity_clot_input_model;
  },
  ssuOutputModel: state => {
    let output_model = JSON.parse(JSON.stringify(state.ssu_output_model));
    output_model.services = [state.connectivity_clot_output_model];
    output_model.metadata.signup_hash = state.init_values.signup_hash;
    return output_model;
  },
  existingConnectivityClotOutputModel: state => {
    return state.connectivity_clot_output_model;
  },
  ssuLoginDetails: state => {
    return {uid: state.ssu_output_model.customer.uid, password: state.ssu_output_model.customer.password};
  }
}

const mutations = {
  [types.SELF_SIGNUP_INITIALIZE_CONNECTIVITY_CLOT] (state, {service}) {
    state.connectivity_clot_input_model = new ConnectivityClotService(service);
    state.address_details = {...service.address_details};
    helpers.setInitialValues(state);
    // set customer address info
    state.ssu_output_model.customer.line1 = state.address_details.line1;
    state.ssu_output_model.customer.line2 = state.address_details.line2;
    state.ssu_output_model.customer.city = state.address_details.city;
    state.ssu_output_model.customer.state = state.address_details.state;
    state.ssu_output_model.customer.zip_code = state.address_details.zip_code;
    if (state.address_details.available) {
      state.connectivity_clot_output_model.service_action_type = clot_action;
      state.connectivity_clot_output_model.connectivity.service_action_type = new_action;
      state.connectivity_clot_output_model.connectivity.external_adid = state.address_details.address_id;
      state.connectivity_clot_output_model.connectivity.early_signup = state.address_details.early_signup;
      state.connectivity_clot_output_model.connectivity.drop_details.needs_ont_install = state.address_details.needs_ont_install;
      // set service class ids
      state.connectivity_clot_output_model.service_class_id = state.connectivity_clot_input_model.service_class_model.service_class_id;
      state.connectivity_clot_output_model.connectivity.service_class_id = state.connectivity_clot_input_model.connectivity.service_class_model.service_class_id;
      state.connectivity_clot_output_model.router.service_class_id = state.connectivity_clot_input_model.router.service_class_model.service_class_id;
      state.connectivity_clot_output_model.voice.service_class_id = state.connectivity_clot_input_model.voice.service_class_model.service_class_id;
      state.connectivity_clot_output_model.static_ip.service_class_id = state.connectivity_clot_input_model.static_ip.service_class_model.service_class_id;
      state.connectivity_clot_output_model.subnet.service_class_id = state.connectivity_clot_input_model.subnet.service_class_model.service_class_id;
      state.connectivity_clot_input_model.connectivity.order_summary.addServiceToCart(true);
      // trigger reactivity updates
      helpers.triggerConnectivityClotUpdate(state);
    }
  },

  [types.SELF_SIGNUP_CONNECTIVITY_SET_CUSTOMER] (state, { is_owner, is_tribal, owner_phone, owner_email, owner_name }) {
    state.connectivity_clot_output_model.connectivity.customer_details.is_owner = is_owner === null ? true : is_owner;
    state.connectivity_clot_output_model.connectivity.customer_details.is_tribal = !!is_tribal;
    state.connectivity_clot_output_model.connectivity.customer_details.owner_phone = owner_phone;
    state.connectivity_clot_output_model.connectivity.customer_details.owner_email = owner_email;
    state.connectivity_clot_output_model.connectivity.customer_details.owner_name = owner_name;
    helpers.triggerConnectivityClotUpdate(state);
    state.connectivity_clot_input_model.setSpeedOptionsForSelect();
  },

  [types.SELF_SIGNUP_CONNECTIVITY_SET_SPEED] (state, {speed_id, external_soid}) {
    state.connectivity_clot_output_model.connectivity.speed_id = speed_id;
    state.connectivity_clot_output_model.connectivity.external_soid = external_soid;
    helpers.triggerConnectivityClotUpdate(state);
    // handle cart
    state.connectivity_clot_input_model.connectivity.setActiveSpeedOption(speed_id);
    state.connectivity_clot_input_model.router.setActiveRouterOption(speed_id);
    state.connectivity_clot_output_model.router.external_soid = state.connectivity_clot_input_model.router.getActiveRouterOption().external_soid;
    state.connectivity_clot_input_model.connectivity.addActiveSpeedOptionToCart();
    // just in case they change speed after choosing a router
    if (state.connectivity_clot_output_model.router.service_action_type === new_action) {
      state.connectivity_clot_input_model.router.addActiveRouterOptionToCart();
    }
  },

  [types.SELF_SIGNUP_CONNECTIVITY_SET_ROUTER] (state, {needs_router, router_model, external_soid, mesh_quantity, mesh_type }) {
    state.connectivity_clot_output_model.router.service_action_type = needs_router ? new_action : none_action;
    state.connectivity_clot_output_model.router.router_model = router_model;
    state.connectivity_clot_output_model.router.external_soid = external_soid;
    state.connectivity_clot_output_model.router.mesh_quantity = mesh_quantity;
    state.connectivity_clot_output_model.router.mesh_type = mesh_type;
    helpers.triggerConnectivityClotUpdate(state);
    state.connectivity_clot_input_model.router.service.mesh_option.billing.prices[0].quantity = mesh_quantity;  // there is only one price for meshes
    if (needs_router){
      logger.debug('connectivity clot input', state.connectivity_clot_input_model)
      state.connectivity_clot_input_model.router.order_summary.addServiceToCart();
      state.connectivity_clot_input_model.router.addActiveRouterOptionToCart();
      if (mesh_quantity > 0) {
        state.connectivity_clot_input_model.router.addMeshOptionToCart();
      } else if (mesh_quantity === 0) {
        state.connectivity_clot_input_model.router.removeMeshOptionFromCart();
      }
    } else if (needs_router === false) {
      state.connectivity_clot_input_model.router.order_summary.removeServiceFromCart();
      state.connectivity_clot_input_model.router.removeRouterOptionFromCart();
      state.connectivity_clot_input_model.router.removeMeshOptionFromCart();
    }
  },

  [types.SELF_SIGNUP_CONNECTIVITY_SET_UTOPIA] (state, { city_customer_id, city_account_id }) {
    state.connectivity_clot_output_model.connectivity.customer_details.city_customer_id = city_customer_id;
    state.connectivity_clot_output_model.connectivity.customer_details.city_account_id = city_account_id;
  },

  [types.SELF_SIGNUP_CONNECTIVITY_SET_STRATA] (state, {install_details, drop_details}) {
    state.connectivity_clot_output_model.connectivity.install_details = {...state.connectivity_clot_output_model.connectivity.install_details, ...install_details};
    state.connectivity_clot_output_model.connectivity.drop_details = {...state.connectivity_clot_output_model.connectivity.drop_details, ...drop_details};
    state.connectivity_clot_output_model.connectivity.drop_details.latitude = String(state.connectivity_clot_output_model.connectivity.drop_details.latitude);
    state.connectivity_clot_output_model.connectivity.drop_details.longitude = String(state.connectivity_clot_output_model.connectivity.drop_details.longitude);
    helpers.triggerConnectivityClotUpdate(state);
  },

  [types.SELF_SIGNUP_CONNECTIVITY_SET_SOUTHERN_UTE] (state, {desired_activation_date}) {
    state.connectivity_clot_output_model.connectivity.install_details.date = desired_activation_date;
    helpers.triggerConnectivityClotUpdate(state);
  },

  [types.SELF_SIGNUP_CONNECTIVITY_SET_VOICE] (state, {contact}) {
    state.connectivity_clot_output_model.voice.service_action_type = contact ? new_action : none_action;
    helpers.triggerConnectivityClotUpdate(state);
  },
  [types.SELF_SIGNUP_SET_ATTRIBUTION_DATA] (state, attribution) {
    state.ssu_output_model.customer.attribution = attribution;
  },
  [types.SELF_SIGNUP_SET_CUSTOMER_DATA] (state, payload) {
    state.ssu_output_model.customer.name = `${payload.fname} ${payload.lname}`;
    state.ssu_output_model.customer = {...state.ssu_output_model.customer, ...payload};
    helpers.setInitialValues(state);
  },
  [types.SELF_SIGNUP_SET_PAYMENT_DATA] (state, payload) {
    state.ssu_output_model.payment = {...state.ssu_output_model.payment, ...payload};
  },
  [types.SELF_SIGNUP_SET_AGREEMENT_DATA] (state, payload) {
    state.ssu_output_model.agreement = {...state.ssu_output_model.agreement, ...payload};
  },
  [types.SELF_SIGNUP_RESET_OUTPUT_MODELS] (state) {
    state.ssu_output_model = getDefaultOutputModel();
    state.connectivity_clot_output_model = getDefaultOutputClotModel();
  },
  [types.SELF_SIGNUP_SET_INIT_VALUES] (state, {signup_hash, data}) {
    logger.debug('setting init values', data);
    state.init_values.signup_hash = signup_hash;
    state.init_values.google_address_id = helpers.getInitialValue('google_address_id', data.service[0], '');
  }
}


const actions = { }


export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/ssu.js